module.exports = __webpack_public_path__ + "img/yingshiwang_b.8f528cca.png";